import React, { ReactElement, useState } from "react";

import { Slider as MuiSlider, SliderProps } from "@mui/material";

import { useDispatch, useSelector } from "../../store";
import { ReduxFormProps } from "@/types/ReduxForm";

export const ReduxSliderField = ({
  getter,
  setter,
  path,
  ...props
}: ReduxFormProps & SliderProps): ReactElement => {
  const dispatch = useDispatch();
  const sliderValue = useSelector(getter(path, 0)) as number;
  const [inputValue, setInputValue] = useState<number>(sliderValue);
  return (
    <MuiSlider
      {...props}
      value={inputValue}
      onChange={(_, newValue): void => {
        if (typeof newValue === "number") {
          setInputValue(newValue);
          dispatch(setter({ path, value: newValue }));
        }
      }}
    />
  );
};
